import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punelocalbusonrent() {



  const cardData = {
"keyword": "Pune Local Bus on Rent",

"headingDescription":
  "Aaradhya Travels offers reliable Pune Local Bus on Rent for city travel, corporate shuttles, school trips, wedding transportation, airport transfers, and group sightseeing within Pune and Pimpri-Chinchwad. Our fleet includes well-maintained AC and Non-AC buses in multiple seating capacities such as 20, 25, 32, 40, and 50-seaters. With experienced drivers, flexible rental plans, and affordable pricing, we ensure safe, punctual, and comfortable local group travel across all major areas of Pune.",

"topPlaces": [

{
"title": "Karnala Bird Sanctuary",
"description":
"Karnala Bird Sanctuary is a protected forest area near Mumbai known for trekking, birdwatching, and nature trails. It is ideal for adventure group trips from Pune."
},
  {
"title": "Ellora Caves",
"description":
"Ellora Caves is a UNESCO World Heritage site near Aurangabad famous for rock-cut temples, sculptures, and ancient Indian architecture. It is a popular long-distance group travel destination from Pune for history and heritage tours."
},
{
"title": "Ajanta Caves",
"description":
"Ajanta Caves are UNESCO-listed Buddhist caves known for ancient paintings, carvings, and historical significance. It is a top cultural and heritage group tour destination from Pune."
},
{
"title": "Matheran",
"description":
"Matheran is Asia’s only automobile-free hill station known for viewpoints, toy train rides, and lush greenery. It is ideal for peaceful group trips from Pune."
},
{
"title": "Harihareshwar",
"description":
"Harihareshwar is a coastal pilgrimage and beach destination known as 'Dakshin Kashi'. It is popular for temple visits, beaches, and group tours from Pune."
},
{
"title": "Diveagar",
"description":
"Diveagar is a clean and less crowded beach destination known for coconut trees, calm waters, and peaceful group outings from Pune."
},
{
"title": "Bhandardara",
"description":
"Bhandardara is a scenic hill station known for Arthur Lake, Randha Falls, and beautiful monsoon views. It is a popular weekend group trip destination from Pune."
},
{
"title": "Amboli",
"description":
"Amboli is a hill station in the Sahyadri range famous for waterfalls, mist, and green valleys. It is ideal for nature and monsoon group tours from Pune."
},
{
"title": "Chiplun",
"description":
"Chiplun is a scenic Konkan town surrounded by rivers, greenery, and ghats. It is a popular long-road group travel destination from Pune."
},
{
"title": "Lavasa",
"description":
"Lavasa is a planned hill city known for lakeside promenade, colorful architecture, cafes, and leisure activities. It is a popular short group trip destination from Pune."
},

],


services: [
  {
    name: "Bus Rental in Pune",
    description: "Bus rental in Pune service provides reliable transportation for family outings, corporate events, educational tours, airport transfers, sightseeing journeys, and outstation travel. Spacious buses and comfortable seating ensure smooth travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient bus rental reservations."
  },
  {
    name: "Bus Hire in Pune",
    description: "Bus hire in Pune service offers dependable transportation for weddings, office outings, family functions, school trips, and tourist travel requirements. Spacious buses and experienced drivers ensure comfortable journeys suitable for local and long-distance travel. Professional chauffeurs ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, schools, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient bus hire reservations."
  },
  {
    name: "32 35 40 45 50 Seater Bus on Rent Pune",
    description: "32 35 40 45 50 seater bus on rent Pune service provides spacious transportation for weddings, educational tours, corporate events, pilgrimage journeys, and family vacations. Comfortable seating and luggage space ensure smooth highway travel suitable for medium and large passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, schools, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient seater bus reservations."
  },
  {
    name: "Pune Darshan Tempo Traveller on Rent",
    description: "Pune Darshan Tempo Traveller on rent service offers comfortable transportation for city sightseeing tours, educational visits, tourist travel, and family outings across Pune attractions. Spacious interiors and smooth local travel ensure pleasant journeys suitable for all passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the Pune Darshan route. Pickup services are available from homes, hotels, railway stations, airports, and commercial locations across Pune. Flexible booking options allow convenient Pune Darshan traveller reservations."
  },
  {
    name: "Pune to Sinhagad Fort Mini Bus on Rent",
    description: "Pune to Sinhagad Fort mini bus on rent service provides reliable transportation for historical tours, educational trips, family outings, and sightseeing journeys from Pune. Spacious seating and smooth travel ensure pleasant journeys suitable for students, tourists, and family groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, schools, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Sinhagad mini bus reservations."
  },
  {
    name: "Pune to Jejuri Bus Hire",
    description: "Pune to Jejuri bus hire service offers comfortable transportation for Khandoba temple darshan tours, spiritual journeys, pilgrimage travel, and family outings from Pune. Spacious buses and smooth highway travel ensure pleasant journeys suitable for devotees and tourist groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Jejuri bus reservations."
  },
  {
    name: "Pune to Ranjangaon Bus Hire",
    description: "Pune to Ranjangaon bus hire service provides dependable transportation for Mahaganpati temple visits, pilgrimage journeys, educational tours, and family travel from Pune. Spacious seating and comfortable interiors ensure smooth highway travel suitable for spiritual and tourist groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Ranjangaon bus reservations."
  },
  {
    name: "Pune to Narayanpur Bus Hire",
    description: "Pune to Narayanpur bus hire service offers reliable transportation for temple visits, sightseeing tours, family outings, and pilgrimage travel from Pune. Spacious buses and comfortable seating ensure smooth journeys suitable for devotees and tourist groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Narayanpur bus reservations."
  },
  {
    name: "Pune to Morachi Chincholi Bus Hire",
    description: "Pune to Morachi Chincholi bus hire service provides comfortable transportation for nature tours, school outings, picnic trips, and sightseeing journeys from Pune. Spacious seating and smooth highway travel ensure pleasant experiences suitable for families, students, and tourist groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, schools, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Morachi Chincholi bus reservations."
  },
  {
    name: "Pune Local Bus Hire for One Day",
    description: "Pune local bus hire for one day service offers affordable transportation for sightseeing trips, office outings, educational tours, weddings, and local group travel. Spacious buses ensure comfortable seating suitable for all passenger groups and short-distance journeys. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, schools, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient one-day local bus reservations."
  },
  {
    name: "Pune Darshan Mini Bus on Rent",
    description: "Pune Darshan mini bus on rent service provides dependable transportation for city sightseeing tours, educational visits, tourist travel, and family outings across Pune attractions. Spacious interiors and smooth local travel ensure pleasant journeys suitable for all passenger groups. Professional drivers ensure safe transportation and reliable pickup services throughout the Pune Darshan route. Pickup services are available from homes, hotels, railway stations, airports, and commercial areas across Pune. Flexible booking options allow convenient Pune Darshan mini bus reservations."
  },
  {
    name: "Pune Local Bus on Rent for Corporate Travel",
    description: "Pune local bus on rent for corporate travel service offers professional transportation for office outings, employee movement, business meetings, conferences, and executive travel. Spacious seating and comfortable interiors ensure smooth journeys suitable for office teams and corporate passengers. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial areas across Pune. Flexible booking options allow convenient corporate bus reservations."
  },
  {
    name: "Pune Local Bus on Rent for Family Function",
    description: "Pune local bus on rent for family function service provides comfortable transportation for birthdays, anniversary celebrations, family gatherings, and special event travel requirements. Spacious buses ensure smooth travel experiences suitable for family groups and local event transportation. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, banquet halls, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient family function bus reservations."
  },
  {
    name: "Pune Local Bus on Rent for Wedding",
    description: "Pune local bus on rent for wedding service offers dependable transportation for bridal parties, wedding guests, family members, and marriage function travel requirements. Spacious seating and smooth travel performance ensure comfortable journeys suitable for wedding ceremonies and celebrations. Professional chauffeurs ensure punctual pickup and reliable transportation services throughout the wedding schedule. Pickup services are available from homes, banquet halls, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient wedding bus reservations."
  },
  {
    name: "Pune Local Bus on Rent for Picnic",
    description: "Pune local bus on rent for picnic service provides affordable transportation for school outings, office trips, family gatherings, sightseeing journeys, and recreational travel. Spacious buses ensure comfortable seating suitable for all age groups and passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, schools, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient picnic bus reservations."
  },
  {
    name: "Pune Local Bus Rental Per KM",
    description: "Pune local bus rental per km service offers flexible and economical transportation for airport transfers, sightseeing tours, business travel, educational trips, and local group journeys. Spacious seating and comfortable interiors ensure smooth travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient per km bus reservations."
  },
  {
    name: "Affordable Bus Hire Pune",
    description: "Affordable bus hire Pune service provides economical transportation for educational tours, weddings, office outings, sightseeing journeys, and family travel requirements. Spacious buses ensure comfortable seating and smooth journeys suitable for local and outstation travel. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, schools, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient affordable bus reservations."
  },
  {
    name: "AC Bus Hire Pune",
    description: "AC bus hire Pune service offers premium air-conditioned transportation for business travel, sightseeing tours, family vacations, airport transfers, and outstation journeys. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient AC bus reservations."
  },
  {
    name: "Non AC Bus Hire Pune",
    description: "Non AC bus hire Pune service provides affordable transportation for educational tours, local sightseeing, school outings, office travel, and group journeys. Spacious seating and smooth travel ensure comfortable experiences suitable for budget-friendly travel requirements. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, schools, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient non AC bus reservations."
  },
  {
    name: "Luxury Bus Hire Pune",
    description: "Luxury bus hire Pune service offers premium transportation for weddings, corporate events, airport transfers, family vacations, sightseeing tours, and outstation journeys. Spacious luxury interiors and comfortable seating ensure smooth travel experiences suitable for executive passengers and tourist groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient luxury bus reservations."
  }
],

tableData: [
  ["Bus Rental in Pune", "Bus Hire in Pune"],
  ["32 35 40 45 50 Seater Bus on Rent Pune", "Pune Darshan Tempo Traveller on Rent"],
  ["Pune to Sinhagad Fort Mini Bus on Rent", "Pune to Jejuri Bus Hire"],
  ["Pune to Ranjangaon Bus Hire", "Pune to Narayanpur Bus Hire"],
  ["Pune to Morachi Chincholi Bus Hire", "Pune Local Bus Hire for One Day"],
  ["Pune Darshan Mini Bus on Rent", "Pune Local Bus on Rent for Corporate Travel"],
  ["Pune Local Bus on Rent for Family Function", "Pune Local Bus on Rent for Wedding"],
  ["Pune Local Bus on Rent for Picnic", "Pune Local Bus Rental Per KM"],
  ["Affordable Bus Hire Pune", "AC Bus Hire Pune"],
  ["Non AC Bus Hire Pune", "Luxury Bus Hire Pune"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune Local Bus on Rent Service",
        WhyChoosedescription: "Aaradhya Travels provides reliable Pune local bus rental service with comfortable vehicles, professional drivers, and smooth travel arrangements for city tours, events, and group transportation."
      },
      {
        WhyChooseheading: "Affordable Local Bus Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Pune local bus on rent packages with transparent pricing, flexible booking options, and complete travel assistance without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Local Bus Booking Service",
        WhyChoosedescription: "Our Pune local bus rental service operates 24 hours for employee transportation, weddings, school trips, airport transfers, corporate events, and local sightseeing tours."
      },
      {
        WhyChooseheading: "Comfortable & Well-Maintained Local Buses",
        WhyChoosedescription: "All buses provided by Aaradhya Travels are spacious, clean, regularly maintained, and available in AC and Non-AC options for safe and comfortable city travel experiences."
      },
      {
        WhyChooseheading: "Flexible One Day & Event Travel Plans",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day local travel, event transportation, office outings, wedding guest transfers, and city tour packages according to customer requirements."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Bus Options",
        WhyChoosedescription: "Customers can choose from 20 seater, 25 seater, 32 seater, 35 seater, 45 seater, and 50 seater buses suitable for family groups, corporate teams, schools, and tourists."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup and drop services from homes, offices, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, Pimpri, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe City Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth local journeys, and timely transportation for all city travel and event transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune local bus on rent service?", answer: "Pune local bus rental service provides comfortable group transportation for city tours, corporate travel, weddings, school trips, and local events." },
    { question: "Is local bus booking available 24 hours in Pune?", answer: "Yes, Aaradhya Travels provides 24/7 local bus rental service in Pune." },
    { question: "Which seating capacity buses are available for local travel?", answer: "Aaradhya Travels offers 20 seater, 25 seater, 32 seater, 35 seater, 45 seater, and 50 seater buses for local group transportation." },
    { question: "Can I book buses for local corporate events?", answer: "Yes, customers can book buses for office outings, conferences, employee transportation, and local corporate travel." },
    { question: "Do you provide AC and Non-AC buses for local travel?", answer: "Yes, Aaradhya Travels provides both AC and Non-AC buses for comfortable and budget-friendly city transportation." },
    { question: "Are the buses maintained properly for local travel?", answer: "Yes, all buses are regularly cleaned and maintained for safe and comfortable local transportation." },
    { question: "Can I book local bus rental service online in Pune?", answer: "Yes, customers can easily book Pune local bus rental service online or through phone booking." },
    { question: "Do you provide buses for weddings and family functions?", answer: "Yes, Aaradhya Travels provides spacious buses suitable for weddings, family functions, and local group events." },
    { question: "Are Pune local bus rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for local bus rental service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and event periods." }
  ];

  const testimonials = [
  {
    id: 1,
    name: "Mr. Harshad Kulkarni",
    feedback:
      "For local travel in Pune, Aaradhya Travels provided a bus on rent that made group movement very easy. The vehicle was clean, and the entire journey across multiple city stops was well managed.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Deshmukh",
    feedback:
      "Aaradhya Travels arranged a Pune local bus on rent for our group event, and everything was handled smoothly. The ride was comfortable, and coordinating multiple pickups was completely hassle-free.",
    rating: 5
  }
];



  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Local Bus on Rent",
  "image": "https://www.aaradhyatravels99.com/assets/images/pune-local-bus-on-rent.jpg",
  "description": "Book Pune Local Bus on rent with Aaradhya Travels for corporate travel, weddings, family functions, picnics, and one-day trips. Available in AC, Non-AC, and luxury buses including 32, 35, 40, 45, and 50 seater options across Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4028"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/pune-local-bus-on-rent"
  }
};









  return (
    <div>
<Helmet>
  <title>
    Pune Local Bus on Rent | AC, Non-AC & Luxury Bus Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Pune Local Bus on rent with Aaradhya Travels. Affordable AC, Non-AC, and luxury buses available for Pune Darshan, Sinhagad Fort, Jejuri, Ranjangaon, Narayanpur, Morachi Chincholi, corporate travel, weddings, and family trips."
  />

  <meta
    name="keywords"
    content="Bus Rental in Pune, Bus Hire in Pune, 32 35 40 45 50 Seater, Pune Darshan Tempo Traveller on rent, Pune to Sinhagad fort mini bus on rent, Pune to Jejuri bus hire, Pune to Ranjangaon bus hire, Pune to Narayanpur bus hire, Pune to Morachi Chincholi bus hire, Pune local bus hire for one day, Pune Darshan mini bus on rent, Pune local bus on rent for corporate travel, Pune local bus on rent for family function, Pune local bus on rent for wedding, Pune local bus on rent for picnic, Pune local bus rental per km, Affordable bus hire Pune, AC bus hire Pune, Non AC bus hire Pune, Luxury bus hire Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/28.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punelocalbusonrent;